import { Button, TextField, Box, Alert, Typography, Autocomplete, FormControl } from "@mui/material";
import { useState, useEffect } from "react";
import CustomLoader from '../../../core/components/common/custom-loader.component';
import CustomFormSuccess from '../../../core/components/common/custom-form-success.component';
import PermissionService from "../services/api/permission-service";
import ModuleService from "../services/api/module-service";
import { useSnackbar } from "notistack";

const EditFunctionModuleForm = ({row, handleClose, handleRecordChange}) => {
    const [moduleList, setModuleList] = useState([]);
    const [selectedModule, setSelectedModule] = useState(''); 
    const [errorMessage, setErrorMessage] = useState();
    const [statusCode, setStatusCode] = useState();
    
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    const { enqueueSnackbar } = useSnackbar();


    const fetchData = () => {
        ModuleService.listModules().then((res) => {
            let apiResponse = res.data;
            setModuleList(apiResponse.data);
            setSelectedModule(row.module_id);
        }).catch((error) => {
            const errorMessage = error?.response?.data?.error || error.message;
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 2000
            });
        });
    };


    useEffect(() => {
        fetchData();
    }, []);


    const handleSubmit = () => {
        setLoading(true); 

        let paramaters = {
            'id': row.id,
            'moduleId' : selectedModule
        }

        console.log(paramaters)
        let request = PermissionService.updatePermissionModule(paramaters);
        request.then((result) => {
            setLoading(false);
            let apiResponse = result.data;
            console.log("apiResponse", apiResponse)
            setSuccess(true)
            handleRecordChange();
        }).catch((error) => {
            console.log("error", error)
            setLoading(false);
            setSuccess(false)
            setStatusCode(error.status)
            const errorMessage = error?.response?.data?.error || error.message;
            setErrorMessage(errorMessage)
        })
    }

    return (
        <div>
             {loading ? ( 
                <CustomLoader/>
            ) : (
                <div>
                    {success ? ( 
                        <CustomFormSuccess handleClose={handleClose}
                            message={"Function's Module was successfully updated"}
                        />
                    ) : (
                    <div>
                        {errorMessage && (
                            <Alert style={{marginBottom: "12px"}} severity="error">
                                {errorMessage}.
                                <Typography sx={{ fontSize: '0.5rem' }}>
                                    Status Code: {statusCode}
                                </Typography>
                            </Alert>
                        )}
                         <Box component="form" sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <FormControl fullWidth>
                                <Autocomplete
                                    id="module-select"
                                    options={moduleList}
                                    getOptionLabel={(option) => option.module_name || ''}
                                    value={selectedModule ? moduleList.find((item) => item.id === selectedModule) : null}
                                    onChange={(e, newValue) => setSelectedModule(newValue ? newValue.id : null)}
                                    renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Select Module"
                                        variant="outlined"
                                    />
                                    )}
                                />
                            </FormControl>
                            <Button type="button" variant="contained" sx={{ alignSelf: 'flex-end' }} onClick={handleSubmit}> Submit</Button>
                        </Box>
                    </div>

                )}
                </div>
            )}
           
        </div>
    )
}
export default EditFunctionModuleForm